import React, { useState } from "react"
import { Icon } from "semantic-ui-react"
import AddUserToGroupView from "../../../../../Pages/MainPanel/MainPanelBody/Groups/GroupModal/EditGroupModal/GroupView/AddUserToGroupView"
import BifrostButton from "../../../../BifrostElementComponent/BifrostButton/BifrostButton"
import BifrostModal from "../../../BifrostModal/BifrostModal"

const AddUserToGroupModal = ({ group, refreshData }) => {
	const [openModal, setOpenModal] = useState(false)

	return (
		<BifrostModal
			title={"Add user to Group"}
			open={openModal}
			setOpen={setOpenModal}
			closeOnEscape={true}
			closeOnDimmerClick={true}
			trigger={
				<BifrostButton>
					<Icon name="add" size="small" />
					Add User
				</BifrostButton>
			}
			modalPage={
				<AddUserToGroupView
					group={group}
					onFinish={() => {
						refreshData()
					}}
				/>
			}
		/>
	)
}

AddUserToGroupModal.propTypes = {}

export default AddUserToGroupModal
